/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto } from '../models/Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettlementConfigurationService {

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppSettlementConfigurationSettlementConfigurationForRsu(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/settlement-configuration/settlement-configuration-for-rsu',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppSettlementConfigurationSettlementConfigurationForOptions(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/settlement-configuration/settlement-configuration-for-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppSettlementConfigurationSettlementConfigurationForPsu(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/settlement-configuration/settlement-configuration-for-psu',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppSettlementConfigurationSettlementConfigurationForEarlyExercise(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_SettlementConfiguration_GetSettlementConfigurationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/settlement-configuration/settlement-configuration-for-early-exercise',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
